/* eslint-disable react-hooks/rules-of-hooks */
import { ApplicationController } from '@application-controller';
import { useClickOutside } from 'stimulus-use';

/** @extends {ApplicationController} */
export class Controller extends ApplicationController {
  static targets = ['menu', 'trigger', 'chevron'];
  static classes = ['closed', 'chevronOpen'];

  connect() {
    useClickOutside(this);
    if (this.hasTriggerTarget) {
      this.triggerTarget.addEventListener('click', this.toggleMenu.bind(this));
      this.updateTriggerState();
    }
  }

  updateTriggerState() {
    const opened = !this.menuTarget.classList.contains(this.closedClass);
    this.triggerTarget.setAttribute('aria-expanded', opened);
    if (this.hasChevronTarget && this.hasChevronOpenClass) {
      this.chevronTarget.classList.toggle(this.chevronOpenClass, opened);
    }
  }

  clickOutside() {
    this.closeMenu();
  }

  closeMenu() {
    if (this.hasMenuTarget && this.hasClosedClass) {
      this.menuTarget.classList.add(this.closedClass);
      this.updateTriggerState();
    }
  }

  toggleMenu() {
    if (this.hasMenuTarget && this.hasClosedClass) {
      this.menuTarget.classList.toggle(this.closedClass);
      this.updateTriggerState();
    }
  }
}
